import Image from 'next/image';
import slide01 from '../../assets/images/footerSlide/slide_image01.png';
import slide02 from '../../assets/images/footerSlide/slide_image02.png';
import slide03 from '../../assets/images/footerSlide/slide_image03.png';
import slide04 from '../../assets/images/footerSlide/slide_image04.png';
import styled, { keyframes } from 'styled-components';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        {/* Left */}
        <LeftSection>
          <SectionTitle>법정의무교육 주관처</SectionTitle>
          <ImageSlider>
            <SliderWrapper>
              <Image  height={40} src={slide01} alt="Slide 1" />
              <Image  height={40} src={slide02} alt="Slide 2" />
              <Image  height={40} src={slide03} alt="Slide 3" />
              <Image  height={40} src={slide04} alt="Slide 4" />
              <Image  height={40} src={slide01} alt="Slide 1" />
              <Image  height={40} src={slide02} alt="Slide 2" />
              <Image  height={40} src={slide03} alt="Slide 3" />
              <Image  height={40} src={slide04} alt="Slide 4" />
            </SliderWrapper>
          </ImageSlider>
        </LeftSection>

        {/* Right */}
        <RightSection>
          <TextBlock>개인정보 처리방침 | 서비스 이용약관</TextBlock>
          <TextBlock>
            <strong>사업자등록번호</strong> 306-87-01683 | <strong>통신판매신고번호</strong> 제 2025-서울종로-0300
          </TextBlock>
          <TextBlock>
            <strong>주소</strong> 서울 종로구 율곡로 6, 트윈 트리 빌딩 A동 17-D호
          </TextBlock>
          <TextBlock>
            <strong>대표</strong> 상현태 I <strong>개인정보취급처리자</strong> 상현태
          </TextBlock>
          <TextBlock>
            <strong>메일</strong> aiden@netstream.co.kr I <strong>전화</strong> 02-839-0602 I <strong>팩스</strong> 02-6008-0602
          </TextBlock>
        </RightSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.div`
  border-top: 1px solid #dee2e6;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
`;

const LeftSection = styled.div`
  width: 50%;
  overflow: hidden;
  padding-top: 10px
`;

const SectionTitle = styled.div`
  font-size: 11.2px;
  color: #868e96;
  font-weight: bold;
  margin-bottom: 10px;
`;

const ImageSlider = styled.div`
  width: 100%;
  overflow: hidden;
`;

const slide = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const SliderWrapper = styled.div`
  display: flex;
  animation: ${slide} 15s linear infinite;
  gap: 10px;
  filter: grayscale(100%);
  opacity: 0.6;
`;

const RightSection = styled.div`
  color: #868e96;
  font-size: 12px;
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 2px;
  ${'' /* letter-spacing: 0.5px; */}
  line-height: 1.2;
`;

const TextBlock = styled.div`
  margin-bottom: 2px;
  font-weight: normal;

  strong {
    font-weight: bold;
  }
`;